<template>
  <div
    v-if="$slots.default"
    class="rt-stateline-item__content"
    :class="['is-' + status]"
  >
    <div
      class="rt-stateline-item__icon rt-stateline-item__content__icon"
      :style="iconStyle"
    >
      <slot name="icon">
        <rt-icon
          v-if="status"
          :name="iconName"
          :size="14"
        />
      </slot>
    </div>
    <div class="rt-stateline-item__description">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import statusIcons from './status-icons';
import RtIcon from '../icon/rtIcon.vue';

export default {
  name: 'RtStatelineContent',
  components: { RtIcon },
  props: {
    status: {
      type: String,
      validator: val => {
        return [
          'wait', // 等待处理
          'process', // 正在处理
          'finish', // 已处理
          'error', // 处理失败
          'success', // 处理成功
          'cancel' // 已取消
        ].includes(val);
      }
    }
  },
  computed: {
    iconName () {
      const status = this.status;

      const iconName = statusIcons[status];

      return iconName || '';
    },
    iconStyle () {
      const status = this.status;

      let style = {};
      if (!status && !this.$slots.icon) {
        style.visibility = 'hidden';
      }

      return style;
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtStatelineContent.vue?4b8d1cae